import React, { Component, Fragment }  from "react";
import moment from "moment";
import Barcode from 'react-barcode';

export default class PrintProductLabel extends Component {
	constructor(props) {
		super(props);
	}
	
	render() {
		const { print_pos_label, facility  } = this.props;

		return (
			<div>
				<style dangerouslySetInnerHTML={{__html: `
					@media print {
						@page {
						  size: 2.25in 1in !important;
						  margin:5px;
						}
						p{
							font-size:10px;
						}
					}
				`}} />
				{print_pos_label['order_products'].map((product,index)=>{
					let weight = ' G';
					if(product['qty_type']==0||product['qty_type']==5||product['qty_type']==6||product['qty_type']==7){
						weight = ' MG';
					}else if(product['qty_type']==2){		
						weight = ' KG';
					}else if(product['qty_type']==3){		
						weight = ' Unit';
					}else if(product['qty_type']==4){		
						weight = ' Liter';
					}
					return (
						<div className="print_pos_label" style={{padding:'2px 10px 2px 3px'}} key={index} >                  
							<div style={{width:'2.25in', height:'1in', fontSize:'12px'}} className="panel-body">
								<div className="row_data">
									Lic#: {facility['license_number']}<br/>								
									Date: {moment(product.timestamp*1000).format("MM/DD/YYYY")}<br/>								
									Total Weight: {product['product_qty']+' '+(product['qty_type']==1 ? "GR":(product['qty_type']==2 ? "KG":(product['qty_type']==4 ? "Liters":"Unit")))}<br/>								
								</div>
								{product['mip_weight']!=null && product['product_type']==1 ? <div className="row_data">
									MIP Weight: {product['mip_weight']+' GR'}
								</div>:""}
								<div className="row_data">
									Stock # {product['barcode']}<br/>
									<strong>{product['product_name']}</strong> 
								</div>
								<div className="row_data text-center">
									<Barcode value={product.barcode} height={20} width={0.95} margin={0} marginTop={5} displayValue={false} />
									<p className="text-center">{(product.barcode.match(/.{1,4}/g)).join(' ')}</p>
								</div>
							</div>
						</div>
					)
				})}
			</div>
		);
	}
};